export default function getLandingImageHeight() {
	if (window.innerWidth < 640) {
		return { width: '100%', height: 420 }; // lock iPhone/small height
	}

	return { width: '100%', maxHeight: '650px' }; // keep prior large-screen behavior
}
